import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {
    FIELD_LIST_INPUT_ABOUT_AVOSKIN_TRAIL_RUN,
    FIELD_NAME_INPUT_ABOUT_AVOSKIN_TRAIL_RUN
} from "../../../utils/input-field-list-static-page";
import {
    setAvoskinTrailRunAboutDetail, setAvoskinTrailRunErrorMessage,
} from "../../../reducers/avoksin-trail-run.reducer";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";
import {convertErrorMessage} from "../../../utils/general-variable";
import React, {useEffect} from "react";
import FormGeneralComponent from "../../../components/static-page/form-general.component";
import InputField from "../../avoskin-trail-run/about-trail-run/input-field";

const AboutTrailRun = () => {
    const dispatch = useDispatch()
    const {aboutAvoskinTrailRunDetail} = useSelector(state => state.avoskinTrailRunReducer)
    const {fetching: getAbout} = useFetch(API.AVOSKIN_TRAIL_RUN_GET_ABOUT)
    const {fetching: updateAbout, isLoading} = useFetch(API.AVOSKIN_TRAIL_RUN_UPDATE_ABOUT)
    let fieldListInput = FIELD_LIST_INPUT_ABOUT_AVOSKIN_TRAIL_RUN
    let showAbout = {
        label: 'About Avoskin Trail Run',
        key: 'show_about',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const toggleList = [
        {
            title: 'Input Field',
            content: <InputField fieldList={fieldListInput}/>
        }
    ]

    const onChange = (key, value) => {
        dispatch(setAvoskinTrailRunAboutDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateAbout(aboutAvoskinTrailRunDetail).then(response => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('About Trail Run Updated'))
            dispatch(setAvoskinTrailRunAboutDetail(response?.data))
        }).catch(err => {
            dispatch(setAvoskinTrailRunErrorMessage(convertErrorMessage(err, {}, FIELD_NAME_INPUT_ABOUT_AVOSKIN_TRAIL_RUN)))
        })
    }

    useEffect(() => {
        getAbout().then(response => {
            dispatch(setAvoskinTrailRunAboutDetail(response?.data))
        })

        return () => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={aboutAvoskinTrailRunDetail}
            switchToggleField={showAbout}
            onChange={onChange}
            toggleList={toggleList}
            onSubmitHandler={onSubmitHandler}
            isLoading={isLoading}
        />
    )
}

export default AboutTrailRun
